module.exports = __webpack_public_path__ + "img/home-hero_jp.1750da3.jpg";